import { defineComponent as r, createBlock as t, openBlock as v, unref as n, mergeProps as h, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const s = /* @__PURE__ */ r({
  name: "IconCardView",
  __name: "IconCardView",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (v(), t(n(p), h(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M4.5 3.25A1.25 1.25 0 0 0 3.25 4.5v5a1.25 1.25 0 0 0 1.25 1.25h5a1.25 1.25 0 0 0 1.25-1.25v-5A1.25 1.25 0 0 0 9.5 3.25h-5m.25 6v-4.5h4.5v4.5h-4.5m-.25 4a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h5a1.25 1.25 0 0 0 1.25-1.25v-5a1.25 1.25 0 0 0-1.25-1.25h-5m.25 6v-4.5h4.5v4.5h-4.5m8.5-14.75a1.25 1.25 0 0 1 1.25-1.25h5a1.25 1.25 0 0 1 1.25 1.25v5a1.25 1.25 0 0 1-1.25 1.25h-5a1.25 1.25 0 0 1-1.25-1.25v-5m1.5.25v4.5h4.5v-4.5h-4.5m-.25 8.5a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h5a1.25 1.25 0 0 0 1.25-1.25v-5a1.25 1.25 0 0 0-1.25-1.25h-5m.25 6v-4.5h4.5v4.5h-4.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
